export default {
  placeholders: {
    first_name: 'Etunimi',
    last_name: 'Sukunimi',
    email: 'Sähköposti',
    mobile_number: 'Matkapuhelinnumero',
  },
  labels: {
    exclusive_offers_via_email: 'Haluan saada erikoistarjouksia ja uutisia sähköpostitse.',
  },
  buttons: {
    sign_up: 'Rekisteröidy',
  },
};
